export default {
      id: "returningTruckHover-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "icons.svg#returningTruckHover",
      toString: function () {
        return this.url;
      }
    }